export default __webpack_public_path__ + "static/media/banner.2f033cf7.jpg";